//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import newMediaTypesMixin from '@/components/mixins/new-mediatypes.mixin.js';
import { newMediaTypes } from '@motionelements/core/src/helpers/newMediaTypes';

export default {
  name: 'LandingHero',
  mixins: [newMediaTypesMixin],
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
  },
  data() {
    return {
      faArrowRight,
      newMediaTypes,
    };
  },
  computed: {
    mediaTypesFull() {
      return newMediaTypes
        .map(item => ({
          ...item,
          ...this.mediaTypes[item.id],
        }));
    },
  },
};
